import { courseMattou, courseTsurugi, courseMikawa, courseHakusanroku } from '../assets/data/courseDict.json';

//private function

const getCourseArray = (areaCode) => {
  switch(areaCode) {
    case 0:
      return courseMattou;
    case 1:
      return courseTsurugi;
    case 2:
      return courseMikawa;
    case 3:
      return courseHakusanroku;
    default:
      return [];
  }
};

const sortArray = (array, maxNumber) => {
  const sortedArray = [];
  array.map((item, index) => {
    if (item.priority < 99) {
      sortedArray[item.priority] = item
    }
    return null;
  });
  const results = sortedArray.filter(Boolean);
  return results.slice(0, maxNumber);
};

const recomendFromArea = (areaCode, itemNumber ) => {
  const courseArray = getCourseArray(areaCode);
  return sortArray(courseArray, itemNumber);
};

const validateChoise = state => {
  const {
    selectedService,
    selectedTV,
    selectedInternet,
    selectedPhone,
  } = state;
  const tv = selectedService.indexOf(0) >= 0;
  const internet = selectedService.indexOf(1) >= 0;
  const phone = selectedService.indexOf(2) >= 0;

  const tvValidation = !tv || selectedTV.length;
  const internetValidation = !internet || selectedInternet.length;
  const phoneValidation = !phone || selectedPhone.length;

  // const set = internet && phone ? 'トリプルサービスセット割引料金' : 'ダブルサービスセット割引料金';
  // const validation = selectedTV.length;
  const validation = tvValidation && internetValidation && phoneValidation;
  // const choosedOnlyTV = !((internet && selectedInternet.length) || phone)

  return {
    validation,
  };
};

const convertToInterger = str => parseInt(str.replace(',', ''), 10)

const convertWeight = (state) => {
  const { areaCode, selectedService, selectedTV, selectedInternet, selectedPhone } = state;
  const tv = selectedService.indexOf(0) >= 0;
  const internet = selectedService.indexOf(1) >= 0;
  const phone = selectedService.indexOf(2) >= 0;

  let tvCourseWeight;
  let internetCourseWeight;
  let phoneCourseWeight;

  if (!(tv && selectedTV.length)) {
    tvCourseWeight = 0;
  } else {
    tvCourseWeight = 3 - selectedTV[0];
  }
  if (!(internet && selectedInternet.length)) {
    internetCourseWeight = 0;
  } else {
    internetCourseWeight = getInternetCourseWeight(selectedInternet[0]);
  }
  if (!(phone && selectedPhone.length)) {
    phoneCourseWeight = 0;
  } else {
    phoneCourseWeight = 2 - selectedPhone[0];
  }

  return {
    tvCourseWeight,
    internetCourseWeight,
    phoneCourseWeight,
  };
};

const getInternetCourseWeight = (selectedInternetIndex) => {
  switch(selectedInternetIndex) {
    case 0:
      return 5;
    case 1:
      return 3;
    case 2:
      return 2;
    default:
      return 0;
  }
}

const isSingle = item => {
  let count = 0;
  const {
    tvCourseWeight,
    internetCourseWeight,
    phoneCourseWeight,
  } = item;

  if (tvCourseWeight) {
    count ++;
  }
  if (internetCourseWeight) {
    count ++;
  }
  if (phoneCourseWeight) {
    count ++;
  }
  return count === 1;
}

const isDoublePhone = item => {
  let count = 0;
  const {
    tvCourseWeight,
    internetCourseWeight,
    phoneCourseWeight,
  } = item;

  if (tvCourseWeight) {
    count ++;
  }
  if (internetCourseWeight) {
    count ++;
  }
  if (phoneCourseWeight) {
    count ++;
  }
  const double = count === 2;

  return double && phoneCourseWeight;
}

const isDouble = item => {
  let count = 0;
  const {
    tvCourseWeight,
    internetCourseWeight,
    phoneCourseWeight,
  } = item;

  if (tvCourseWeight) {
    count ++;
  }
  if (internetCourseWeight) {
    count ++;
  }
  if (phoneCourseWeight) {
    count ++;
  }
  return count === 2;
}

const isTripple = item => {
  let count = 0;
  const {
    tvCourseWeight,
    internetCourseWeight,
    phoneCourseWeight,
  } = item;

  if (tvCourseWeight) {
    count ++;
  }
  if (internetCourseWeight) {
    count ++;
  }
  if (phoneCourseWeight) {
    count ++;
  }
  return count === 3;
}

const recomendFromChoise = state => {
  const { itemNumber, areaCode, choosedPlans } = state;

  const { validation } = validateChoise(state);
  if (!validation) { return choosedPlans };

  const courseArray = getCourseArray(areaCode);
  let results;

  const {
    tvCourseWeight,
    internetCourseWeight,
    phoneCourseWeight,
  } = convertWeight(state);

  const suitable = courseArray.filter(item => item.tvCourseWeight === tvCourseWeight)
                      .filter(item => item.internetCourseWeight === internetCourseWeight)
                      .filter(item => item.phoneCourseWeight === phoneCourseWeight)
                      .filter(item => item.priority < 10000) // priority10000以上のものは検索条件完全一致でも表示しない
                      .filter(item => item.best = true)

  const suitablePrice = suitable.length ? convertToInterger(suitable[0].discountPrice) : 0;
  let doublePhoneExisted = suitable.length ? isDoublePhone(suitable[0]) : false;

  const filteredArray = courseArray.filter((item, index) => {
    if (isSingle(item)) { return false } // 単体プランは１つしかださない
    if (tvCourseWeight > item.tvCourseWeight) { return false } // tvコースウェイトが低いものははじく
    if (internetCourseWeight > item.internetCourseWeight) { return false } // ネットコースウェイトが低いものははじく
    if (phoneCourseWeight > item.phoneCourseWeight) { return false } // 電話コースウェイトが低いものははじく
    if (phoneCourseWeight !== item.phoneCourseWeight) { return false } // 電話ケーブルライン選択時はケーブルプラスはださない
    if (areaCode !== 3 && item.internetCourseWeight === 1) { return false } // ネットがお手軽1Mのものははじく
    if (areaCode===0 && item.tvCourse === 'ライトコース') { return false } // 松任エリアのライトコースははじく

    const discountPrice = convertToInterger(item.discountPrice);
    const highPrice = suitablePrice < discountPrice;
    return highPrice;
  });

  for (let i = 0; i < filteredArray.length; i++){
    for (let j = filteredArray.length-1; j > i ; j-- ){
        const price = convertToInterger(filteredArray[j].discountPrice);
        const priceNext = convertToInterger(filteredArray[j-1].discountPrice);
        if (price < priceNext) {
            let tmp = filteredArray[j];
            filteredArray[j] = filteredArray[j-1];
            filteredArray[j-1] =tmp;
        } else if (price === priceNext) {
          if (isDouble(filteredArray[j-1]) && isTripple(filteredArray[j])) { //トリプルを優先的にだす
            let tmp = filteredArray[j];
            filteredArray[j] = filteredArray[j-1];
            filteredArray[j-1] =tmp;
          }
        }
    }
  }

  const recommendations = filteredArray.filter((item, index) => {
    if (internetCourseWeight > 1) {
      if (item.internetCourseWeight === 1) {
        return false;
      }
    }

    const doublePhone = isDoublePhone(item);
    if (doublePhone && !doublePhoneExisted) {
      doublePhoneExisted = true;
    } else if (doublePhone && doublePhoneExisted) {
      return false;
    }

    return true;
  })
  .filter(item => {
    item.best = false
    return item;
  });

  results = suitable.concat(recommendations).splice(0, itemNumber)

  return results;
};

//action
export const SET_AREA_CODE = 'SET_AREA_CODE';
export const SELECT_TAB = 'SELECT_TAB';
export const SELECT_SERVICE = 'SELECT_SERVICE';
export const SELECT_TV = 'SELECT_TV';
export const SELECT_INTERNET = 'SELECT_INTERNET';
export const SELECT_PHONE = 'SELECT_PHONE';
export const TOGGLE_SHOW_ALL = 'TOGGLE_SHOW_ALL';

export const setAreaCode = areaCode => ({
  type: SET_AREA_CODE,
  areaCode,
});

export const selectTab = selected => ({
  type: SELECT_TAB,
  selected,
});

export const selectService = selected => ({
  type: SELECT_SERVICE,
  selected,
});

export const selectTV = selected => ({
  type: SELECT_TV,
  selected,
});

export const selectInternet = selected => ({
  type: SELECT_INTERNET,
  selected,
});

export const selectPhone = selected => ({
  type: SELECT_PHONE,
  selected,
});

export const toggleShowAll = () => ({
  type: TOGGLE_SHOW_ALL,
});

//reducer
const initialState = {
  itemNumber: 12,
  selectedTab: [],
  selectedService: [],
  selectedTV: [],
  selectedInternet: [],
  selectedPhone: [0],
  recomendedPlans: [],
  choosedPlans: [],
  areaCode: 0,
  showAll: false,
};

const reducer = (state = initialState, action) => {
  let nextState;
  let choosedPlans;
  let { selectedPhone } = state;
  switch(action.type) {
    case SET_AREA_CODE:
      const { areaCode } = action;
      const recomendedPlans = recomendFromArea(areaCode, state.itemNumber);
      return {
        ...state,
        areaCode,
        recomendedPlans,
      };

    case SELECT_TAB:
      return {
        ...state,
        selectedTab: [ action.selected ],
      };

    case SELECT_SERVICE:
      const  { selected } = action;

      const selectedService = [...state.selectedService];
      const arrayIndex = selectedService.indexOf(selected);
      if ( arrayIndex === -1) {
        selectedService.unshift(selected);
      } else {
        selectedService.splice(arrayIndex, 1);
      }

      if (selectedService.indexOf(1) === -1) {
        selectedPhone = [0];
      }

      nextState = {
        ...state,
        selectedService,
        selectedPhone,
      };
      choosedPlans = recomendFromChoise(nextState);

      return {
        ...nextState,
        choosedPlans,
      };

    case SELECT_TV:
      nextState = {
        ...state,
        selectedTV: [ action.selected ],
      };
      choosedPlans = recomendFromChoise(nextState);
      return {
        ...nextState,
        choosedPlans,
      };

    case SELECT_INTERNET:
      if (action.selected === 4) {
        selectedPhone = [0];
      }
      nextState = {
        ...state,
        selectedInternet: [ action.selected ],
        selectedPhone,
      };
      choosedPlans = recomendFromChoise(nextState);
      return {
        ...nextState,
        choosedPlans,
      };

    case SELECT_PHONE:
      nextState = {
        ...state,
        selectedPhone: [ action.selected ],
      };
      choosedPlans = recomendFromChoise(nextState);
      return {
        ...nextState,
        choosedPlans,
      };

    case TOGGLE_SHOW_ALL:
      return {
        ...state,
        showAll: !state.showAll,
      };

    default:
      return state;
  }
};

export default reducer;
